import React from 'react'
import { connect } from 'react-redux'
import { fetchLicenses } from '../../actions/license-actions'
import { Grid, Row } from 'react-bootstrap'
import qs from 'qs'

import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'
import SearchResults from './search-results'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'

class LicenseOverview extends React.Component {
  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query })
      this.props.fetchLicenses(params.query)
    }
  }

  search(query) {
    this.props.fetchLicenses(query)
  }

  render() {
    const { searchResults } = this.props

    return (
      <Grid>
        <Breadcrumbs />
        <SearchBar
          value={this.state.query || searchResults.query}
          action="/licenties"
          placeholder="Zoek licentie"
          callback={(query) => this.search(query)}
        />

        <Row>
          <div className="tablescontainer">
            {searchResults.length > 0 ? (
              <SearchResults searchResults={searchResults} history={this.props.history} full={true} />
            ) : (
              <SearchInfo />
            )}
          </div>
        </Row>
      </Grid>
    )
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>Activatiecode</li>
      <li>WebshopOrderItemId</li>
      <li>Navision ID</li>
      <li>Klantnaam</li>
      <li>Groepsnaam</li>
      <li>
        Gebruiker
        <ul>
          <li>User ID</li>
          <li>Email</li>
          <li>Voornaam</li>
          <li>Achternaam</li>
        </ul>
      </li>
      <li>
        Product
        <ul>
          <li>Naam</li>
          <li>EAN</li>
        </ul>
      </li>
    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)

export default connect(
  (state) => {
    return { searchResults: state.licenses.searchResults }
  },
  {
    fetchLicenses,
  }
)(LicenseOverview)
